import { Label } from 'reactstrap';
import React from 'react';
import classNames from 'classnames';
import { InfoTooltip, InfoTooltipProps } from './InfoTooltip';

interface Props extends Pick<InfoTooltipProps, 'placement'> {
  id?: string;
  for?: string;
  tooltip: string;
  className?: string;
  labelClassName?: string;
}

export const TooltipLabel: React.FC<Props> = (props) => {
  return (
    <div
      className={classNames(
        props.className,
        'd-inline-flex align-items-center'
      )}
    >
      <Label for={props.for} id={props.id} className={props.labelClassName}>
        {props.children}
      </Label>
      <InfoTooltip
        className="ml-25 mb-50"
        text={props.tooltip}
        placement={props.placement}
      />
    </div>
  );
};
